import {GRID_DATE_COL_DEF, GridColTypeDef, GridRenderEditCellParams, useGridApiContext} from "@mui/x-data-grid";
import {TimePicker} from "@mui/x-date-pickers";
import {TextField} from "@mui/material";
import React from "react";
import Util from "../../utils/Util";


const GridEditTimeCell = ({id, field, value, colRef}: GridRenderEditCellParams<Date | string | null>) => {
  const apiRef = useGridApiContext();
  const timeFieldStyle = {
    '.MuiOutlinedInput-notchedOutline': {border: "none"},
    // '.MuiOutlinedInput-input': {textAlign: "left", marginLeft: "10px"},
    // '.css-1yq5fb3-MuiButtonBase-root-MuiIconButton-root': {marginRight: "10px"}
  }
  return (
    <TimePicker
      ampm={false}
      onChange={async (newValue) => {
        await apiRef.current.setEditCellValue({id, field, value: newValue});
      }}
      value={value}
      renderInput={(props) => {
        return <TextField
          fullWidth={true}
          sx={timeFieldStyle}
          {...props}
        />
      }}
    />
  )
}
export const timeColumnType: GridColTypeDef<Date | string, string> = {
  ...GRID_DATE_COL_DEF,
  resizable: false,
  renderEditCell: (params) => {
    return <GridEditTimeCell {...params} />
  },
  valueGetter: (params) => {
    if(typeof params.value === "string"){
      return Util.time2datetime(params.value);
    }
    return params.value;
  }
}
